export default "__VITE_ASSET__CfghpdOy__"